import searchRequest from "../../requests/search";
import trackInfo from "../../requests/trackInfo";
import { getChannel } from "../../requests/channels";
export const types = {
  SEARCH_REQUEST: 'SEARCH_REQUEST',
  SEARCH_FAILURE: 'SEARCH_FAILURE',
  ARTISTS_RESULT: 'ARTISTS_RESULT',
  TRACKS_RESULT: 'TRACKS_RESULT',
  ALBUMS_RESULT: 'ALBUMS_RESULT',
  CHANNELS_RESULT: 'CHANNELS_RESULT',
  USERS_RESULT: 'USERS_RESULT'
}

export const search = ({ type, text, page, size }) => {
  return (dispatch) => {
    dispatch({
      type: types.SEARCH_REQUEST
    })
    Promise.all([
      searchRequest({
        type,
        text,
        page,
        size
      }),
      new Promise(resolve => {
        if (!!(1 * text) && type === 'track') {
          resolve(trackInfo(text));
        } else {
          resolve({ data: { [`${type}s`]: [] } })
        }
      }),
      new Promise(resolve => {
        if (!!(1 * text) && type === 'channel') {
          getChannel(text)
            .then(res => {
              if (res.data) resolve({ data: { channels: [res.data] } })
            })
        } else {
          resolve({ data: { [`${type}s`]: [] } })
        }
      })
    ])
      .then(responsesArray => {
        let data;
        switch (type) {
          case 'track':
            data = [...responsesArray[0].data.tracks, ...responsesArray[1].data.tracks];
            break;
          case 'channel':
            data = [...responsesArray[0].data.channels, ...responsesArray[2].data.channels];
            break;
          case 'user':
            data = responsesArray[0].data;
            break;
          default:
            data = responsesArray[0].data[`${type}s`];
            break;
        }

        dispatch({
          type: types[`${type.toUpperCase()}S_RESULT`],
          payload: data || null
        })
      })
      .catch(error => {
        dispatch({
          type: types.SEARCH_FAILURE,
          error
        })
      })
  }
}